import "./CustomRadioInput.scss";
import Typhography from "../Typhography/Typhography";
import { objectToClassString } from "../../utils/functions";
import classNames from "classnames";

export interface ICustomRadioInput<
  T extends readonly Record<"label" | "value", string>[]
> {
  label?: string;
  value?: string;
  disabled?: boolean;
  onChange?: (value: T[number]["value"]) => void;
  options: T;
}

const CustomRadioInput = <
  T extends readonly Record<"label" | "value", string>[]
>({
  label,
  options,
  disabled = false,
  onChange,
  value,
}: ICustomRadioInput<T>) => {
  const renderRadio = (option: ICustomRadioInput<T>["options"][0]) => (
    <div
      className={`container__radio ${classNames({ disabled })}`}
      key={option.value}
      onClick={() =>
        !disabled && onChange?.(option.value as T[number]["value"])
      }
    >
      <div
        className={classNames({
          container__circle: true,
          selected: value === option.value,
          disabled: disabled,
        })}
      >
        <div
          className={`circle ${classNames({
            selected: value === option.value,
            disabled,
          })}`}
        />
      </div>
      <Typhography
        type="span"
        size="medium-14"
        className={classNames({ label__disabled: disabled })}
      >
        {option.label}
      </Typhography>
    </div>
  );

  return (
    <div className="container__custom__radio__input">
      <Typhography size="bold-14">{label}</Typhography>
      <div className="container__group__radio">
        {options.map((option) => renderRadio(option))}
      </div>
    </div>
  );
};

export default CustomRadioInput;
